import { useSnackbar } from "notistack";
import { State } from "../../../domain/model/ResponseState";
import { LoginAnonymouslyUseCase } from "../../../domain/usecase/auth/LoginAnonymously/UseCase";
import { showGlobalLoadingView } from "../../../core/utils/Utils";
import SharedPreferences from "../../../core/utils/SharedPreferences";
import { STORAGE_KEYS } from "../../../data/constant/Constants";
import { useState } from "react";
import { SchoolType } from "../../../domain/model/User";

export function LandingViewModel(
  loginAnonymouslyUseCase: LoginAnonymouslyUseCase,
) {
  const [schoolType, setSchoolType] = useState<SchoolType>(SchoolType.PRIMARY);
  const { enqueueSnackbar } = useSnackbar();

  async function loginAsGuest() {
    showGlobalLoadingView(true);
    const response = await loginAnonymouslyUseCase.invoke({ schoolType });
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        SharedPreferences.setString(
          STORAGE_KEYS.TOKEN,
          response.data?.accessToken!,
        );
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error",
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return { loginAsGuest, schoolType, setSchoolType };
}
